import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-custom-alert',
  templateUrl: './custom-alert.component.html',
  styleUrls: ['./custom-alert.component.scss']
})
export class CustomAlertComponent implements OnInit {
	MAX_INDEX_POPUPS = 2;
	gifPath: any;
	title: any;
	subTitle: any;
	accessType: any;

	quizPopupData = [
		{
			title: "Hey Hero!",
			subTitle: "Submit your quiz<br> and I'll meet you at<br> the next D.O.S.E!"
		},
		{
			title: "Hey Superstar!",
			subTitle: "Submit your quiz<br> and get to the next<br> D.O.S.E!<br> You got this!"
		},
		{
			title: "Hey Hero!",
			subTitle: "It looks like you didn't submit your quiz yet!<br> Did you know if you don't get 100%, you<br> can try again?"
		}
	];

	downloadPopupData = [
		{
			title: "Hey Superstar!",
			subTitle: "Remember your<br> download!"
		},
		{
			title: "Hey Hero!",
			subTitle: "Don't forget<br> your download!"
		},
		{
			title: "Oops!",
			subTitle: "It looks like you<br> forgot your<br> download!"
		}
	];

	completedPopupData = [
		{
			title: "Woo Hoo!",
			subTitle: "Congratulations<br> on completing<br> this program!"
		},
		{
			title: "Way to Go!",
			subTitle: "Great job on<br> completing this<br> program!"
		},
		{
			title: "You did it!",
			subTitle: "Another program<br> complete!<br> Keep filling that<br> skills bucket,<br> Superstar!"
		},
	];

	videoPopupData = [
		{
			title: "Hey Superstar!",
			subTitle: "It looks like you<br> still have some<br> tasks to finish."
		},
		{
			title: "Hey Hero!",
			subTitle: "Finish the previous<br> tasks and I'll see<br> you at the next<br> D.O.S.E!"
		},
		{
			title: "Oops!",
			subTitle: "Finish the previous<br> tasks to get to the<br> next D.O.S.E!"
		},
	];

  	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<CustomAlertComponent>
	) {}

	ngOnInit() {
		if (this.data.type === "quiz" || this.data.type === "completed") {
			this.gifPath = "../../../../assets/gifs/Flip_Hands_Up_Happy_200px.gif";
		} else if (this.data.type === "download" || this.data.type === "video") {
			this.gifPath = "../../../../assets/gifs/Flip_Wink_Wave_200px.gif";
		}

		let typeOrder: any = localStorage.getItem(`${this.data.type}PopupOrder`);
		this.accessType = eval(`this.${this.data.type}PopupData`);
		// console.log(this.accessType);

		if (typeOrder && Number(typeOrder) !== this.MAX_INDEX_POPUPS) {
			typeOrder = Number(typeOrder);
			this.title = this.accessType[typeOrder + 1].title;
			this.subTitle = this.accessType[typeOrder + 1].subTitle;
			typeOrder += 1;
		} else if (!typeOrder || Number(typeOrder) === this.MAX_INDEX_POPUPS) {
			this.title = this.accessType[0].title;
			this.subTitle = this.accessType[0].subTitle;
			typeOrder = 0;
		}
		localStorage.setItem(`${this.data.type}PopupOrder`, typeOrder);
	}

	closeAlert() {
		this.dialogRef.close();
	}
}
